import React from "react"
import {useNavigate} from "react-router-dom";
import "./styles.css"
import BottomButtons from "../../components/button-groups/bottom-buttons/BottomButtons";
import TravelComponentsTable from "../../container/travel-components/travel-components-table/TravelComponentsTable";
import {useAppSelector} from "../../redux/reducer/store";
import {PATH_STRINGS} from "../../routes/route-props";

const TravelComponentsOverview = () => {
    const {activities} = useAppSelector(state => state.travelComponents)
    const navigate = useNavigate()

    return <div className={"travel-components-overview-container"}>
        <TravelComponentsTable/>
        {activities.length > 0 && <BottomButtons
            buttons={[
                {
                    text: "GENERAL.ABORT",
                    variant: "abort",
                    onClick: () => navigate(-1)
                },
                {
                    text: "SCREENS.TRAVEL_OPTIONS_OVERVIEW.ADD",
                    onClick: () => navigate(PATH_STRINGS.selectTravelComponents)
                },
            ]}
        />}
    </div>
}

export default TravelComponentsOverview